import React from "react";
import { Leaf } from "lucide-react";
import { lineLabel } from "@/lib/lines";

// Coloured line badge: emerald for Reco Pneus (brand), green + leaf for
// L'Écrin du Sud. Nothing rendered when the call has no line.
export const LineBadge = ({ line, testid = "line-badge", compact = false }) => {
  const label = lineLabel(line);
  if (!label) return null;
  const base = compact
    ? "inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[10px] font-semibold whitespace-nowrap"
    : "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold border whitespace-nowrap";
  const tone = line === "ecrin_du_sud"
    ? "bg-green-50 text-green-700 border border-green-200"
    : "bg-emerald-50 text-emerald-700 border border-emerald-200";
  return (
    <span data-testid={testid} data-line={line} className={`${base} ${tone}`}>
      {line === "ecrin_du_sud" && <Leaf className={compact ? "h-2.5 w-2.5" : "h-3 w-3"} />}
      {label}
    </span>
  );
};
